import { useMemo, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { PARAMETER_MAP } from "../../util/PARAMETER_MAP";
import "./SmartChart.css";
import { Button, Box, Typography } from '@mui/material';
import * as echarts from "echarts";
export default function SmartChart({ history, paramId, loading, height = 250 }) {

  const safeHeight =
    typeof height === "number" && height > 0 ? height : 250;

  const chartRef = useRef(null);
  const initialZoomRef = useRef(null);
  const chartIdRef = useRef(`chart-${Math.random()}`);
  const DISPLAY_TZ = "America/Sao_Paulo";

  const zoomTimeFmt = useMemo(
    () =>
      new Intl.DateTimeFormat("pt-BR", {
        timeZone: DISPLAY_TZ,
        hour: "2-digit",
        minute: "2-digit"
      }),
    []
  );

  // ================================
  // AJUSTE PARA EVITAR "SERROTE"
  // ================================
  const data = useMemo(() => {

    if (!history?.length) return [];

    const result = [];

    for (let i = 0; i < history.length; i++) {
      const t = Number(history[i].timestamp);
      const v = Number(history[i].value);
      result.push([t, v]);
    }

    return result;

  }, [history]);

  const option = useMemo(() => {

    if (!initialZoomRef.current && data.length > 0) {
      const endValue = data[data.length - 1][0];
      const startValue = endValue - (20 * 60 * 1000);

      initialZoomRef.current = { startValue, endValue };
    }

    return {
      useUTC: false,
      backgroundColor: "#ffffff",

      grid: {
        left: 50,
        right: 20,
        top: 30,
        bottom: 65
      },

      tooltip: {
        trigger: "axis",
        backgroundColor: "#ffffff",
        borderColor: "#ddd",
        textStyle: { color: "#333" }
      },

      xAxis: {
        type: "time",
        boundaryGap: false,
        axisLine: { lineStyle: { color: "#ccc" } },
        axisLabel: {
          color: "#666",
          formatter: (value) =>
            new Date(value).toLocaleTimeString("pt-BR")
        },
        splitLine: {
          show: true,
          lineStyle: { color: "#f0f0f0" }
        }
      },

      yAxis: {
        type: "value",
        axisLine: { lineStyle: { color: "#ccc" } },
        axisLabel: { color: "#666" },
        splitLine: { lineStyle: { color: "#f0f0f0" } }
      },

      dataZoom: [
        {
          type: "inside",
          filterMode: "none"
        },
        {
          type: "slider",
          height: 35,
          filterMode: "none",
          bottom: 5,
          handleSize: "110%",
          textStyle: {
            color: "#666",
            fontSize: 11
          },
          labelFormatter: function (value) {
            return zoomTimeFmt.format(new Date(value));
          },
          showDetail: true,
          showDataShadow: true,
          dataBackground: {
            lineStyle: {
              color: "#bba6ec",
              width: 1
            },
            areaStyle: {
              color: "rgba(177, 157, 224, 0.1)"
            }
          },
          backgroundColor: "#fafafa",
          fillerColor: "rgba(139,92,246,0.15)",
          borderColor: "#ddd"
        }
      ],

      series: [
        {
          name: PARAMETER_MAP[paramId]?.name || paramId,
          type: "line",
          step: "end",
          smooth: false,

          // melhora visualização de telemetria
          sampling: "max",
          connectNulls: false,

          showSymbol: true,
          symbolSize: 6,

          lineStyle: {
            width: 2,
            color: "#8b5cf6"
          },

          areaStyle: {
            color: "rgba(139,92,246,0.15)"
          },

          itemStyle: {
            color: "#8b5cf6"
          },

          data
        }
      ]
    };

  }, [data, paramId, zoomTimeFmt]);

  if (!paramId) {
    return (
      <div style={{
        height: safeHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        Selecione um parâmetro
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{
        height: safeHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        Carregando...
      </div>
    );
  }

  if (!data.length) {
    return (
      <div style={{
        height: safeHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        Sem dados disponíveis
      </div>
    );
  }

  const handleZoom = () => {
    if (chartRef.current && data.length > 0) {

      const chart = chartRef.current.getEchartsInstance();

      chart.dispatchAction({
        type: "dataZoom",
        start: 0,
        end: 100
      });
    }
  };

  return (
    <div style={{ width: "100%", height: safeHeight, position: "relative" }}>

      <Button
        onClick={handleZoom}
        className="btn-reset-zoom"
      >
        Resetar Zoom
      </Button>

      <ReactECharts
        ref={chartRef}
        option={option}
        style={{ height: "100%" }}
        notMerge={false}
        lazyUpdate={true}
        onChartReady={(chart) => {
          chart.group = chartIdRef.current;
          echarts.disconnect(chartIdRef.current);
        }}
      />

    </div>
  );
}